export const Tab = {
  Deliverables: 'deliverables',
  Progress: 'progress',
  InvestmentBalance: 'investmentBalance',
} as const;

export type Tab = (typeof Tab)[keyof typeof Tab];
